import { InjectionToken } from '@angular/core';

/**
 * A query a Ryn answer offers to open in Ryn Workbench (WI 37362 slice 2b-2a). The same shape as the Workbench
 * contracts' `SqlShare`, kept local so this shared panel never imports the Workbench contracts (and their secret
 * scanners) into every app that hosts Ask Ryn. Connection is a NAME: the recipient's Workbench opens the query on
 * their own matching connection, and nothing ever runs on arrival.
 */
export interface AskRynSqlShare {
  sql: string;
  connection: string;
  database?: string;
  params?: { name: string; value: string }[];
}

/**
 * A host's way to open a shared query from an Ask Ryn answer. The IT Portal builds its https `/workbench-open` link;
 * a host that provides nothing shows the SQL with no link. `href` returns null for a share the host refuses (a
 * secret in it, an over-long link), which hides the link on that block only.
 */
export interface AskRynWorkbenchShare {
  label: string;
  title: string;
  href(share: AskRynSqlShare): string | null;
}

export const ASK_RYN_WORKBENCH_SHARE = new InjectionToken<AskRynWorkbenchShare>(
  'ASK_RYN_WORKBENCH_SHARE'
);
